

































































import { Event } from '@ssp/inscreva-sse-models';
import DatePicker from '@ssp/ss-commons-front/src/components/DatePicker.vue';
import { Component, Vue, Prop } from 'vue-property-decorator';

import Stepper, { StepperOptions, StepperInfo } from '@/components/base/Stepper.vue';
import StepCheckIn from '@/components/StepCheckIn.vue';
import StepConfirmation from '@/components/StepConfirmation.vue';
import StepEmail from '@/components/StepEmail.vue';
import StepInfo from '@/components/StepInfo.vue';
import StepRegistration from '@/components/StepRegistration.vue';
import StepSite from '@/components/StepSite.vue';

import toast from './toast';
import { ToastType } from './toast/tost-type.enum';

@Component({
  components: {
    Stepper,
    StepInfo,
    StepCheckIn,
    StepSite,
    StepEmail,
    StepRegistration,
    StepConfirmation,
    DatePicker,
  },
})
export default class EventFormComponent extends Vue {
  @Prop({ required: true })
  private event!: Event;

  private currentStep: number = 0;

  private touchedSteps: Array<number> = [];

  private steps: Array<StepperInfo> = [
    { identifier: 'geral', title: 'Geral' },
    { identifier: 'check-in', title: 'Check-in' },
    { identifier: 'site', title: 'Site' },
    { identifier: 'email', title: 'E-mail' },
    { identifier: 'formulario', title: 'Formulário' },
    { identifier: 'confirmacao', title: 'Confirmacao' },
  ];

  private stepperOptions: StepperOptions = {
    dots_first: true,
    animated: false,
    show_title: true,
  };

  $refs!: {
    stepper: Stepper;
  };

  updateCurrentStep(index: number) {
    this.currentStep = index;
  }

  get is_first_step() {
    return this.currentStep === 0;
  }

  get is_last_step() {
    return this.currentStep === this.steps.length - 1;
  }

  submit(passes: any) {
    return passes(() => this.$emit('on-submit', this.event));
  }

  onUpdateEvent(event: Event) {
    this.$emit('on-change', event);
  }

  nextPrev(index: number) {
    const highestTouchedStep = [].concat(this.touchedSteps.sort((a, b) => a - b)).pop();
    if (!(this.currentStep + 1 === index || highestTouchedStep + 1 >= index || this.event._id)) {
      return toast(
        'Atenção, para avançar para esta etapa é necessário preenchar as outras anteriores',
        ToastType.WARNING,
      );
    }

    if (!this.touchedSteps.find((elm) => elm === index)) {
      this.touchedSteps.push(index);
    }
    window.location.hash = '';
    return this.$refs.stepper.nextPrev(index);
  }

  get allow_submit(): boolean {
    return this.is_last_step || !!this.event._id;
  }

  goBack() {
    return this.nextPrev(this.currentStep - 1);
  }

  goForward(passes: any) {
    return passes(() => this.nextPrev(this.currentStep + 1));
  }

  handleStep(index: number, passes: any) {
    if (this.currentStep >= index) {
      this.nextPrev(index);
    } else {
      return passes(() => this.nextPrev(index));
    }
  }
}
